import React from 'react';
import SouthIcon from '@mui/icons-material/South';
import EastIcon from '@mui/icons-material/East';

export const directionOptions = [
	{ value: true, label: <SouthIcon /> },
	{ value: false, label: <EastIcon /> }
];
